import { render, staticRenderFns } from "./CareerAiLauncher.vue?vue&type=template&id=57a66cf1&scoped=true"
import script from "./CareerAiLauncher.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAiLauncher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CareerAiLauncher.vue?vue&type=style&index=0&id=57a66cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a66cf1",
  null
  
)

export default component.exports